import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import ItemCoupon from '../../components/item/item_coupon'
import PageSubHeader from '../../components/common/page_sub_header'
import {MenuMy} from '../../config/page_route'
import CouponRegisterModal from '../../components/control/modal/modal_coupon_register'
import {rootStore} from '../../mobx/store'

const Coupon = observer((props) => {
  const context = useContext(Page_settings)
  let [couponList, setCouponList] = useState([])
  let [useCnt, setUseCnt] = useState(0)
  let [endCnt, setEndCnt] = useState(0)
  let [showCouponModal, setShowCouponModal] = useState(false)

  const active = 4

  useEffect(() => {
    getCouponList()
  }, [])

  const getCouponListRegister = (info) => {
    setShowCouponModal(false)
    getCouponList()
  }

  const getCouponList = () => {
    context.post('pay/coupon_list', {},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setCouponList(response.list)
        setUseCnt(response.total_cnt)
        setEndCnt(response.expire_cnt)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMy} active={active} onCoupon={getCouponList} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.mypage} pageMenu1={strings.main} pageMenu2={strings.mypage} pageMenu={strings.coupon_list}/>
          <div className='term-content-area2'>
            <div className='btn-coupon-register d-center cursor-point sm-mt-12 fs-15 sm-fs-14 f-m' onClick={() => {setShowCouponModal(true)}}>{strings.coupon_register}</div>
            <div className='fs-20 sm-fs-16 f-b mt-5 sm-mt-20'>{strings.coupon}</div>
            <div className='coupon-num-area d-flex'>
              <div className='flex-full '>
                <div className='fs-14 sm-fs-12 f-m'>{strings.use_available}</div>
                <div className='fs-22 sm-fs-18 color-0a3962 f-b'>{useCnt + strings.gae}</div>
              </div>
              <div className='title-divider1'/>
              <div className='flex-full pl-40 sm-pl-0'>
                <div className='fs-14 sm-fs-12 f-m'>{strings.reach_end}</div>
                <div className='fs-22 sm-fs-18 color-0a3962 f-b'>{endCnt + strings.gae}</div>
              </div>
            </div>
            {
              couponList.map((it, idx) => {
                return (
                  <ItemCoupon key={idx} info={it}/>
                )
              })
            }
          </div>
          <CouponRegisterModal show={showCouponModal} toggle={() => {setShowCouponModal(!showCouponModal)}} onConfirm={(value)=> {getCouponListRegister(value)}}/>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(Coupon)
